import { find, get, isEmpty, map, values } from 'lodash'

import { METADATA_TYPES } from '../constants'

const buildCategoriesTreeHierarchy = (
  categoriesTreeData,
  parentKey = '',
  path = '',
  parentPath = '',
  keyPath = [],
  level = 1,
) =>
  map(categoriesTreeData, (item, index) => ({
    ...item,
    key: isEmpty(parentKey) ? `${index}` : `${parentKey}-${index}`,
    path: isEmpty(path) ? `[${index}]` : `${path}[${index}]`,
    keyPath: isEmpty(keyPath)
      ? [`${index}`]
      : [...keyPath, `${parentKey}-${index}`],
    parentPath,
    level,
    allowedOperations: get(
      find(
        values(METADATA_TYPES),
        ({ valueSingular }) => valueSingular === item.type,
      ),
      'allowedOperations',
      [],
    ),
    children: !isEmpty(item.children)
      ? buildCategoriesTreeHierarchy(
          item.children,
          isEmpty(parentKey) ? `${index}` : `${parentKey}-${index}`,
          isEmpty(path) ? `[${index}].children` : `${path}[${index}].children`,
          isEmpty(parentPath)
            ? `[${index}]`
            : `${parentPath}.children[${index}]`,
          isEmpty(keyPath)
            ? [`${index}`]
            : [...keyPath, `${parentKey}-${index}`],
          level + 1,
        )
      : undefined,
  }))

export default buildCategoriesTreeHierarchy
